// extracted by mini-css-extract-plugin
export var container = "_cw-0";
export var icon = "_cw-1";
export var text = "_cw-2";